import type { FC } from "react";
import { useState } from "react";
import { Dialog, DialogActions, DialogContent, DialogTitle, Stack, TextField } from "@mui/material";
import CancelButton from "../../components/cancelButton/CancelButton";
import AsyncLoadingButton from "../../components/asyncLoadingButton/AsyncLoadingButton";
import type { CustomerTagCategory } from "./customerTagsApi";
import { Select } from "../../components/select/Select";

const categories: CustomerTagCategory[] = [
  "Obszar",
  "Oferta dla",
  "Na WWW",
  "Pracuję nad",
  "Aktywność",
  "Segment",
  "Inne",
  "TravelPay",
];

interface DialogProps {
  readonly open: boolean;
  readonly category: CustomerTagCategory;
  readonly tagName: string;
  readonly onChange: (category: CustomerTagCategory, name: string) => Promise<void>;
  readonly onClose: () => void;
}

const EditCustomerTagDialog: FC<DialogProps> = ({ open, category: initialCategory, tagName, onChange, onClose }) => {
  const [name, setName] = useState(() => tagName);
  const [category, setCategory] = useState(() => initialCategory);
  return (
    <Dialog open={open} onClose={onClose} fullWidth>
      <DialogTitle>Edytuj tag klienta</DialogTitle>
      <DialogContent>
        <Stack
          direction="column"
          spacing={2}
          sx={{
            marginTop: 2,
          }}
        >
          <Select
            fullWidth
            label="Kategoria"
            values={categories.map((value) => ({ value }))}
            value={category}
            onSelect={setCategory}
          />
          <TextField label="Nazwa" value={name} onChange={(e) => setName(e.target.value)} fullWidth />
        </Stack>
      </DialogContent>
      <DialogActions>
        <CancelButton onClick={onClose} />
        <AsyncLoadingButton
          disabled={name.trim().length === 0 || (name === tagName && category === initialCategory)}
          onClick={async () => {
            await onChange(category, name);
            onClose();
          }}
        >
          Zapisz
        </AsyncLoadingButton>
      </DialogActions>
    </Dialog>
  );
};

export default EditCustomerTagDialog;
